module.exports = __webpack_public_path__ + "img/1525736843.2497b6dc.jpg";